import React, { useState } from "react";
import { Image } from "react-bootstrap";

// internal
import HighlightShapeThree from "svg/highlight-shape-3";
import shape from "assets/img/faq/faq-shape-1.png";
import SingleFaq from "./single-faq";

// single nav item
function NavItem({ active, id, icon, title, handleTabClick }) {
  const handleClick = () => {
    handleTabClick(id); // Call the parent component function to update the active state
  };

  return (
    <button
      className={`nav-link ${active ? "active" : ""}`}
      onClick={handleClick} // Add onClick event handler
      // Rest of the code...
    >
      <span>{icon}</span>
      {title}
    </button>
  );
}

// tab contents
function TabContent({ active, id, accordion_items }) {
  const [openId, setOpenId] = useState(
    () => accordion_items.find((item) => item.show)?.id || null
  );

  return (
    <div
      className={`tab-pane fade ${active ? "show active" : ""}`}
      id={id}
      role="tabpanel"
      aria-labelledby={`${id}-tab`}
    >
      <div className="accordion" id={`${id}_accordion`}>
        {accordion_items.map((item, i) => (
          <SingleFaq
            key={i}
            item={{
              ...item,
              parent: `${id}_accordion`,
            }}
            isOpen={openId === item.id}
            onToggle={() =>
              setOpenId((currentId) => currentId === item.id ? null : item.id)
            }
          />
        ))}
      </div>
    </div>
  );
}

const StartUpFaqs = ({ element_faq = false }) => {
  const [activeTab, setActiveTab] = useState("rionick");

  const faqGroups = {
    rionick: [
      {
        id: "rionick-one",
        show: true,
        title: "What services does Rionick Studios provide?",
        desc: "Rionick Studios is a creative production studio providing 3D design, CGI, animation, 2D design, game assets, interactive 3D experiences, social media marketing, and other digital creative solutions.",
      },
      {
        id: "rionick-two",
        title: "Do you work with both brands and agencies?",
        desc: "Yes. We work directly with brands, startups, agencies, and other creative studios, either handling complete projects or supporting specific parts of their production pipeline.",
      },
      {
        id: "rionick-three",
        title: "Can Rionick handle complete 3D production?",
        desc: "Yes. Depending on the project, our team can handle modeling, texturing, lighting, animation, rendering, optimization, and interactive implementation.",
      },
      {
        id: "rionick-four",
        title: "How can I get a quotation for my project?",
        desc: "Share your requirements, references, deliverables, and expected timeline with us. We'll review the scope and provide a project-specific quotation.",
      },
    ],
    ghar360: [
      {
        id: "ghar360-one",
        show: true,
        title: "What is Ghar360?",
        desc: "Ghar360 creates interactive property experiences that allow buyers to explore and understand upcoming or under-construction properties before they are built.",
      },
      {
        id: "ghar360-two",
        title: "What Ghar360 solutions are available?",
        desc: "We offer two solutions: an Interactive Walkthrough on Web for easy online property exploration, and a Personalized Mobile App that can bring multiple projects, apartment layouts, and advanced features together under your brand.",
      },
      {
        id: "ghar360-three",
        title: "What features are available in the Ghar360 mobile app?",
        desc: "Features can include Interactive Walkthrough, Raw vs Fully Furnished views, Actual Balcony View, Vastu Compass, Auto Home Tour, AI Sales Agent, Top View, Gyroscope, Screenshot & Share, multiple apartment layouts, and more.",
      },
      {
        id: "ghar360-four",
        title: "Can Ghar360 be customized for our real estate brand?",
        desc: "Yes. The application can be customized around your branding, projects, apartment layouts, floor plans, galleries, and project-specific requirements.",
      },
      {
        id: "ghar360-five",
        title: "How long does it take to create a Ghar360 experience?",
        desc: "A web-based interactive walkthrough can typically be delivered in 7-10 days. Mobile application timelines depend on the number of projects, layouts, features, and customization required.",
      },
    ],
    arrise: [
      {
        id: "arrise-one",
        show: true,
        title: "What is AR-Rise?",
        desc: "AR-Rise transforms traditional print and offline marketing into interactive Augmented Reality experiences that users can access through their smartphones.",
      },
      {
        id: "arrise-two",
        title: "What can be made interactive with AR-Rise?",
        desc: "Business cards, brochures, packaging, posters, standees, postcards, newspaper ads, outdoor creatives, and other printed marketing materials can be enhanced with AR experiences.",
      },
      {
        id: "arrise-three",
        title: "What can users experience through AR-Rise?",
        desc: "Depending on the campaign, users can experience videos, 3D elements, animations, interactive buttons, social links, contact information, gamified experiences, and more.",
      },
      {
        id: "arrise-four",
        title: "Does the customer need to install an app?",
        desc: "No. AR-Rise experiences can be designed for direct smartphone access through a QR-based flow, making them practical for marketing campaigns and printed materials.",
      },
      {
        id: "arrise-five",
        title: "Can AR-Rise track campaign performance?",
        desc: "Yes. AR campaigns can include analytics such as views, unique users, engagement time, location, device information, and other available interaction data.",
      },
    ],
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  return (
    <>
      <section
        className={`faq__area  py-5 z-index-1 pb-${
          element_faq ? "105" : "120"
        }`}
      >
        {!element_faq && (
          <div className="faq__shape">
            <Image loading="lazy" className="faq__shape-1" src={shape} alt="shape" />
          </div>
        )}
        <div className="container">
          <div className="row">
            <div className="col-xxl-5 col-xl-5 col-lg-6">
              <div className="faq__wrapper">
                <div className="section__title-wrapper-7 mb-60">
                  <span className="section__title-pre-7">
                    {element_faq ? "Tab Accordion" : "Common Questions"}
                  </span>
                  {!element_faq && (
                    <h3 className="section__title-7">
                      Frequently <br /> asked{" "}
                      <span className="section__title-7-highlight">
                        questions
                        <HighlightShapeThree />
                      </span>
                    </h3>
                  )}
                  {element_faq && (
                    <h3 className="section__title-7">
                      Accordion <br /> with{" "}
                      <span className="section__title-7-highlight">
                        rounded tab
                        <HighlightShapeThree />
                      </span>
                    </h3>
                  )}
                </div>

                <div className="faq__tab tp-tab pr-200">
                  <nav>
                    <div
                      className="nav nav-tabs flex-column"
                      id="nav-tab"
                      role="tablist"
                    >
                      <NavItem
                        active={activeTab === "rionick"}
                        id="rionick"
                        icon={<i className="fa-regular fa-circle-question"></i>}
                        title="Rionick Studios"
                        handleTabClick={handleTabClick}
                      />
                      <NavItem
                        active={activeTab === "ghar360"}
                        id="ghar360"
                        icon={<i className="fa-regular fa-comments"></i>}
                        title="Ghar360"
                        handleTabClick={handleTabClick}
                      />
                      <NavItem
                        active={activeTab === "arrise"}
                        id="arrise"
                        icon={<i className="fa-solid fa-cube"></i>}
                        title="AR-Rise"
                        handleTabClick={handleTabClick}
                      />
                      {/* <NavItem
                        active={activeTab === "community"}
                        id="community"
                        icon={<StartUpFaqTwo />}
                        title="Community"
                        handleTabClick={handleTabClick}
                      />
                      <NavItem
                        active={activeTab === "support"}
                        id="support"
                        icon={<StartUpFaqThree />}
                        title="Support"
                        handleTabClick={handleTabClick}
                      /> */}
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <div className="col-xxl-7 col-xl-7 col-lg-6">
              <div className="faq__tab-content tp-accordion">
                <div className="tab-content" id="nav-tabContent">
                  <TabContent
                    active={activeTab === "rionick"}
                    id="nav-rionick"
                    accordion_items={faqGroups.rionick}
                  />
                  <TabContent
                    active={activeTab === "ghar360"}
                    id="nav-ghar360"
                    accordion_items={faqGroups.ghar360}
                  />
                  <TabContent
                    active={activeTab === "arrise"}
                    id="nav-arrise"
                    accordion_items={faqGroups.arrise}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StartUpFaqs;
